module.exports = __webpack_public_path__ + "static/media/session3grayscale.ca83e3a3.svg";